<footer class="flex flex-col items-center bg-[#F9FAFB] lg:mt-[100px] mt-[200px] text-[#293056]">
  <div class="container -mt-[11.25rem] md:-mt-24 lg:-mt-16">
    <iho-footer-features />
  </div>
  <nav class="container bg-[#F9FAFB] flex flex-wrap flex-col gap-4 mb-4 md:mb-0 md:flex-row justify-between md:gap-8"
    [class.mt-16]="showLinks">
    <ng-container *ngIf="showLinks">
      <h3 class="text-[#293056] text-xl font-bold">شهرهای پر بازدید با بیشترین
        رزرو</h3>
      <ul class="grid w-full lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 mt-3 list-disc list-inside">
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/bushehr-hotels/">
            <span class="text-lg">هتل های بوشهر</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/tehran-hotels/">
            <span class="text-lg">هتل های تهران</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/mashhad-hotels/">
            <span class="text-lg">هتل های مشهد</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/babolsar-hotels/">
            <span class="text-lg">هتل های بابلسر</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/ramsar-hotels/">
            <span class="text-lg">هتل های رامسر</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/qeshm-hotels/">
            <span class="text-lg">هتل های قشم</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a href="/yazd-hotels/">
            <span class="text-lg">هتل های یزد</span>
          </a>
        </li>
        <li class="md:col-auto text-[#293056] text-semi-bold text-center md:text-right">
          <a [href]="['/tabriz-hotels/']">
            <span class="text-lg">هتل های تبریز</span>
          </a>
        </li>
      </ul>
    </ng-container>

    <div class="w-full flex flex-col md:flex-row justify-between">
      <nav class="md:grid md:grid-cols-3 md:gap-16 md:mt-10 w-full md:w-3/5 ">

        <ng-container *ngTemplateOutlet="mobileAccordionTemplate"></ng-container>

        <ul class="hidden md:flex md:flex-col md:gap-1">
          <li class="flex justify-between items-center font-bold text-base mb-8 cursor-pointer md:cursor-default"
            #expandControl>
            <h6 class="text-[#293056] !text-[16px] !font-semi-bold">ایران هتل آنلاین</h6>
            <i class="font-bold not-italic text-[#293056] text-2xl md:hidden">></i>
          </li>
          <li class="text-sm text-[#293056] font-semi-bold">
            <a href="https://www.iranhotelonline.com/persian/about-us/" id="link-aboutus"
              target="_blank" class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">درباره
              ما</a></li>
          <li class="text-sm text-[#293056] font-semi-bold"><a
            id="link-contactus"
              href="https://www.iranhotelonline.com/persian/contact-us/" target="_blank"
              class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">تماس
              با ما</a></li>
          <li class="text-sm text-[#293056] font-semi-bold"><a href="https://www.iranhotelonline.com/blog/"
              target="_blank" class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">بلاگ</a></li>
          <li class="text-sm text-[#293056] font-semi-bold"><a
              id="link-job"
              href="https://www.iranhotelonline.com/persian/job-opportunities/" target="_blank"
              class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">فرصت‌
              شغلی</a></li>
        </ul>

        <ul class="hidden md:flex md:flex-col md:gap-1">
          <li class="flex justify-between items-center font-bold text-base mb-8" #expandControl>
            <h6 class="text-[#293056] !text-[16px] !font-semi-bold">اطلاعات تکمیلی</h6>
            <i class="font-bold text-[#293056] text-2xl md:hidden">></i>
          </li>
          <li class="text-sm text-[#293056] font-semi-bold">
            <a href="https://www.iranhotelonline.com/province/"
             id="link-province"
              target="_blank" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
              مقاصد سفر</a></li>
          <li class="text-sm text-[#293056] font-semi-bold">
            <a  id="link-privacypolicy"
              href="https://www.iranhotelonline.com/persian/privacypolicy/" target="_blank"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">حریم
              شخصی</a></li>
          <li class="text-sm text-[#293056] font-semi-bold">
            <a href="https://b2b.iranhotelonline.com/" target="_blank" id="link-b2b"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
              راهکارهای سازمانی</a></li>

        </ul>

        <ul class="hidden md:flex md:flex-col md:gap-1">
          <li class="flex justify-between items-center font-bold text-base mb-8" #expandControl>
            <h6 class="text-[#293056] !text-[16px] !font-semi-bold">خدمات مشتریان</h6>
            <i class="font-bold text-[#293056] text-2xl md:hidden">></i>
          </li>
          <li class="text-sm text-[#293056] font-semi-bold"><a
             id="link-price-guarantee"
              href="https://www.iranhotelonline.com/persian/best-price-guarantee/" target="_blank"
              class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">گارانتی
              بهترین نرخ</a></li>
          <li class="text-sm text-[#293056] font-semi-bold">
            <a href="https://www.iranhotelonline.com/reviews/"
              id="link-reviews"
              target="_blank" class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">نظرات
              هتل ها</a></li>
          <li class="text-sm text-[#293056] font-semi-bold"><a href="/"
           
              class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">راهنمای
              رزرو</a></li>
          <li class="text-sm text-[#293056] font-semi-bold"><a
             id="link-policy"
            href="https://www.iranhotelonline.com/persian/policy/"
              target="_blank" class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">قوانین
              رزرو</a></li>
        </ul>
      </nav>

      <nav class="flex w-full flex-col mt-4 px-4 md:px-0   md:w-1/4">
        <div class="flex justify-center items-center my-3 lg:justify-between w-full">
          <!-- <h6 class="text-base text-yellow-400 font-bold mb-8">همیشه همراهتان
            هستیم</h6> -->
          <a routerLink="/" aria-label="" class="hidden lg:block">
            <img [ngSrc]="cdnUrl + '/images/iho-logo.png'" priority role="logo"
              alt="ایران هتل آنلاین | رزرو هتل، هتل آپارتمان، اقامتگاه‌های بوم گردی، اقامت بلند مدت" height="24"
              width="152">
          </a>
        </div>
        <ul class="flex flex-col gap-2 mb-6 footer-bottom-divider-border pb-4 md:pb-0 md:!border-none">
          <li class="flex justify-between items-center !font-semi-bold text-[14px] text-[#293056]">
            <p class="!font-semi-bold text-[14px]">تلفن پشتیبانی</p>
            <a href="tel:{{phoneNumber}}">
              <p class="!font-semi-bold text-[14px]" id="phoneNumber">{{phoneNumber}}</p>
            </a>
          </li>
          <li class="flex justify-between items-center !font-semi-bold text-[14px] text-[#293056]">
            <p class="!font-semi-bold text-[14px]">کد پستی</p>
            <a href="mailto:supply@iranhotelonline.com">
              <span class="!font-semi-bold text-[14px]">7941897285</span>
            </a>
          </li>
          <a class="flex justify-center items-center lg:hidden" routerLink="/" aria-label="">
            <img [ngSrc]="cdnUrl + '/images/iho-logo.png'" priority role="logo"
              alt="ایران هتل آنلاین | رزرو هتل، هتل آپارتمان، اقامتگاه‌های بوم گردی، اقامت بلند مدت" height="24"
              width="152">
          </a>
        </ul>
        <div class="w-full flex justify-right items-center gap-2">
          <a class="mx-auto" href="https://trustseal.enamad.ir/?id=47690&Code=F63V0nMgktoFSmfXgHV5">
            <img class="self-end" [src]="cdnUrl + '/images/e-namad.png'" height="64px" width="64px" alt="E-namad">
          </a>
          <a class="flex bg-[#F9FAFB] border border-solid border-[#EBEBEC]  rounded-2xl p-2 items-center" 
          target="_blank"
          href="https://cafebazaar.ir/app/com.iranhotelonline.twa">
            <img class="self-end border border-solid border-[#EBEBEC] rounded-2xl ml-2" [src]="'assets/images/bazar.png'" height="64px" width="64px" alt="bazar">
            <div>
              <h6 class="text-base font-bold whitespace-nowrap">دانلود اپلیکیشن</h6>
              <p class="text-[#777A80] text-sm">ایران هتل آنلاین</p>
            </div>
          
            </a>
          </div>
       
      </nav>
    </div>
  </nav>

  <div class="bg-[#F9FAFB] w-full flex flex-col pb-4">
    <div
      class="container flex justify-between items-center flex-wrap footer-top-divider-border overflow-y-hidden mb-16 md:mb-0 text-center">
      <p class="text-[#293056] flex justify-center md:block font-normal text-xs w-full lg:w-fit text-center">کلیه
        حقوق وبسایت و اپلیکیشن موبایل محفوظ و متعلق به شرکت ایران هتل آنلاین
        می‌باشد.</p>
      <section class="flex items-center justify-center lg:justify-end mt-2 w-full lg:w-fit">
        <a href="https://www.instagram.com/iranhotelonline_iho/?hl=fa#:~:text=%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%20%D9%87%D8%AA%D9%84%20%D8%A2%D9%86%D9%84%D8%A7%DB%8C%D9%86%20%7C%20%D8%B1%D8%B2%D8%B1%D9%88%20%D9%87%D8%AA%D9%84,%E2%80%A2%20Instagram%20photos%20and%20videos"
          target="_blank" title="iranhotel's instagram" matRipple
          class="flex items-center justify-center rounded-full h-10 w-10 cursor-pointer"><i
            class="ico ico-Instagram !text-2xl text-[#293056]"></i></a>

        <!--TODO replace these -->
        <a matRipple href="https://t.me/Iranhotelonline"
          class="flex items-center justify-center rounded-full h-10 w-10 cursor-pointer"><i
            class="ico-Telegram !text-2xl text-[#293056]"></i></a>
     
        <a matRipple href="https://www.aparat.com/IranHotelOnline"
          class="flex items-center justify-center rounded-full h-10 w-10 cursor-pointer">
        <!-- <i class="ico-Aparat1 !text-2xl text-[#293056]"></i> -->
         <img src="assets/images/aparat.svg" alt="aparat" class="w-[32px] h-[32px] cursor-pointer">
        </a>
        <a matRipple href="https://www.linkedin.com/company/iranhotelonline-com/"
          class="flex items-center justify-center rounded-full h-10 w-10 cursor-pointer">
          <!-- <i class="ico-Linkedin !text-2xl text-[#293056]"></i> -->
          <img src="assets/images/linkedin.svg" alt="aparat" class="h-8 w-8 cursor-pointer">
          </a>
      </section>
    </div>
  </div>
</footer>

<ng-template #mobileAccordionTemplate>
  <mat-accordion class="custom-footer-accordion !w-full md:hidden" multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="!w-full !px-4">
        <mat-panel-title>
          <h6 class="text-[#293056] !font-semi-bold text-[14px]">ایران هتل آنلاین</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <li class="text-sm text-[#293056]"><a href="https://www.iranhotelonline.com/persian/about-us/" 
         id="link-aboutus"
        target="_blank"
          class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">درباره
          ما</a></li>
      <li class="text-sm text-[#293056]"><a href="https://www.iranhotelonline.com/persian/contact-us/" 
         id="link-contactus" target="_blank"
          class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">تماس
          با ما</a></li>
      <li class="text-sm text-[#293056]">
        <a  id="link-job" href="https://www.iranhotelonline.com/persian/job-opportunities/"
          target="_blank" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">فرصت‌
          شغلی</a></li>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header class="!w-full !px-4">
        <mat-panel-title>
          <h6 class="text-[#293056] !font-semi-bold text-[14px]">اطلاعات تکمیلی</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <li class="text-sm text-[#293056]">
        <a href="https://www.iranhotelonline.com/province/" target="_blank" id="link-province"
          class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">مقاصد سفر</a></li>
      <li class="text-sm text-[#293056]"><a id="link-privacypolicy"
         href="https://www.iranhotelonline.com/persian/privacypolicy/"
          target="_blank" class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">حریم
          شخصی</a></li>
      <li class="text-sm text-[#293056]"><a href="https://b2b.iranhotelonline.com/" 
        id="link-b2b"
        target="_blank"
          class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">
          راهکارهای سازمانی</a></li>

    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header class="!w-full !px-4">
        <mat-panel-title>
          <h6 class="text-[#293056] !font-semi-bold text-[14px]">خدمات مشتریان</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <li class="text-md text-[#293056]"><a   id="link-price-guarantee"
        href="https://www.iranhotelonline.com/persian/best-price-guarantee/"
          target="_blank" class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">گارانتی
          بهترین نرخ</a></li>
      <li class="text-sm text-[#293056]"><a href="https://www.iranhotelonline.com/reviews/" 
        id="link-reviews"
        target="_blank"
          class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">نظرات
          هتل ها</a></li>
      <li class="text-sm text-[#293056]"><a href="/"
          class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">راهنمای
          رزرو</a></li>
      <li class="text-sm text-[#293056]"><a   id="link-policy"
         href="https://www.iranhotelonline.com/persian/policy/" target="_blank"
          class="py-1 block cursor-pointer px-0 hover:pr-1 transition-all">قوانین
          رزرو</a></li>

    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
